module.exports = __webpack_public_path__ + "static/media/card2.266418cd.png";